import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import {
    updateUser,meInfo,Passwordupdate
} from '../../services/user'

@Module({
    namespaced: true,
})
export default class ProfileUpdate extends VuexModule {

    // state 
    meTenant = null;
    
    @Action
    public async updateTenant(payload) {
        try {
            const data = await updateUser('partner',payload.id, payload.data);
            return data
        } catch (error) {
            throw error

        }
    }
    @Action
    public async UpdatePassword(payload) {
        try {
            const data = await Passwordupdate('partner',payload);
            return data
        } catch (error) {
            throw new Error(error.response)

        }
    }

    @Action
    public async fetchmeTenant(payload) {
        try {
            const data = await meInfo('partner');
            this.context.commit('setmeTenant', data.response.user);
            return data
        } catch (error) {
            // throw error
        }
    }
    // mutations 

    @Mutation
    public setmeTenant(data: any) {
        this.meTenant = data;
    }
    
    
    
    // getters
    get GetmeTenant() {
        return this.meTenant;
    }

}